module.exports = __webpack_public_path__ + "static/media/28_TOP_FRENTE_UNICA_COM_BOJO_ESTAMPADO_01.0091118d.jpg";